import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import MinipayLanding from "src/content/minipay/Landing";
import useAuth from "src/hooks/useAuth";

import SuspenseLoader from "src/components/SuspenseLoader";
import MinipayGuest from "src/content/minipay/MinipayGuest";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const MinipayLoginCover = Loader(
  lazy(() => import("src/content/minipay/Login/Cover"))
);
const MinipayRegisterCover = Loader(
  lazy(() => import("src/content/minipay/Register/Cover"))
);
const MinipayRecoverPassword = Loader(
  lazy(() => import("src/content/minipay/RecoverPassword"))
);
const MinipayResetPassword = Loader(
  lazy(() => import("src/content/minipay/ResetPassword"))
);
const MinipayEmailValidation = Loader(
  lazy(() => import("src/content/minipay/EmailValidation"))
);
const MinipayEmailVerify = Loader(
  lazy(() => import("src/content/minipay/EmailVerify"))
);

const MinipayHomeRoute = () => {
  const auth = useAuth();
  if (!auth.isInitialized) return null;
  if (auth.isAuthenticated) {
    return <Navigate to="/minipay/main" replace />;
  }
  return <MinipayLanding />;
};

const minipayRoutes = [
  {
    path: "",
    element: <MinipayHomeRoute />,
  },
  {
    path: "login",
    element: (
      <MinipayGuest>
        <MinipayLoginCover />
      </MinipayGuest>
    ),
  },
  {
    path: "register",
    element: (
      <MinipayGuest>
        <MinipayRegisterCover />
      </MinipayGuest>
    ),
  },
  {
    path: "recover-password",
    element: <MinipayRecoverPassword />,
  },
  {
    path: "reset-password",
    element: <MinipayResetPassword />,
  },
  {
    path: "emailValidation/:email",
    element: <MinipayEmailValidation />,
  },
  {
    path: "verifyemail/*",
    element: <MinipayEmailVerify />,
  },
];

export default minipayRoutes;
